import { render, staticRenderFns } from "./ModAgregarCentroCosto.vue?vue&type=template&id=50336b16"
import script from "./ModAgregarCentroCosto.vue?vue&type=script&lang=js"
export * from "./ModAgregarCentroCosto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports